import notificationWithIcon from '@/utils/notification';

/**
 * Извлекает сообщение об ошибке из объекта ошибки API
 * @param {Error} error - Объект ошибки
 * @returns {string} Сообщение об ошибке
 */
export function getErrorMessage(error) {
  return error?.response?.data?.message || error?.message || 'Unknown error';
}

/**
 * Показывает уведомление об ошибке
 * @param {Error} error - Объект ошибки
 */
export function showErrorNotification(error) {
  const message = getErrorMessage(error);
  notificationWithIcon('error', message);
}
